import {
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
} from "./actionTypes";

export const fetchDashboardData = () => ({
  type: FETCH_DASHBOARD_DATA,
});

export const fetchDashboardSuccess = (data) => ({
  type: FETCH_DASHBOARD_SUCCESS,
  payload: data,
});

export const fetchDashboardFailure = (error) => ({
  type: FETCH_DASHBOARD_FAILURE,
  payload: error,
});
